export const maxWidthMap = Object.freeze({
  large: ["100%", "900px"],
  medium: ["100%", "640px"],
  small: ["100%", "500px"],
});

export type MaxWidth = keyof typeof maxWidthMap;
